import React from 'react';
import {Grid} from 'semantic-ui-react';
import './Prize.css';
import PrizeContainerTitle from './PrizeContainerTitle';

export default (props) => {
    return (
        <Grid style={{margin: "1rem 0"}} stackable divided>
            <Grid.Row centered>
                <PrizeContainerTitle title={props.title} title_2={props.title_2} />
            </Grid.Row>
            <Grid.Row stretched className="circle-container" columns={props.children.length}>
                {props.children}
            </Grid.Row>
        </Grid>
    )
}


// WEBPACK FOOTER //
// ./src/components/prizes/PrizesContainer.jsx